import { BasePage } from "../../common/BasePage";
import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { EventDrawView } from "./EventDrawView";
import { IMoveEvent } from "../../../interfaces/IMoveEvent";

export const InfoPage = () => {
  return (
    <BasePage>
      <h2>О проекте</h2>
      <hr />
      <p>
        Это приложение предназначено для поиска мероприятий в городе!.
        Информация о мероприятиях собирается из телеграмм каналов города. C
        помощью ИИ алгоритмов бот пытается определить приглашение на
        мероприятие, извлечать дату мероприятия, определить тематику.
        <br />
        <p><br></br>Возможны неточности, точную информацию уточняйти в источнике.</p>
        <p>
          Приветствуется обратная связь. Если вы хотите, чтобы ваш канал был добавлен в выборку - пишите.
          По вопросам и предложениям пишите <br></br>
          <a href="https://t.me/zahardjagaev">Сюда</a>.
        </p>
      </p>
    </BasePage>
  );
};
